import React, { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';
const ExhibitionistStripConfigPopover = /*#__PURE__*/ lazy(()=>import(/* webpackChunkName: "owner" */ '../../ExhibitionistStripConfigPopover'));
const ExhibitionistStripConfigPopoverLazy = (props)=>{
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(WidgetConfigPopover, {
            isLoading: true,
            onClose: ()=>null
        })
    }, /*#__PURE__*/ React.createElement(ExhibitionistStripConfigPopover, props));
};
ExhibitionistStripConfigPopoverLazy.displayName = 'ExhibitionistStripConfigPopoverLazy';
export default ExhibitionistStripConfigPopoverLazy;
